import { render, staticRenderFns } from "./dev-stat-history.vue?vue&type=template&id=44e2d0f9&scoped=true"
import script from "./dev-stat-history.vue?vue&type=script&lang=js"
export * from "./dev-stat-history.vue?vue&type=script&lang=js"
import style0 from "./dev-stat-history.vue?vue&type=style&index=0&id=44e2d0f9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2d0f9",
  null
  
)

export default component.exports